module.exports = __webpack_public_path__ + "static/media/480.3b4a6084.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-physical-therapy/light/480.png
// module id = 2330
// module chunks = 2